import { useEffect } from "react";
import type { FormData, EvaluationType_Option } from "../types";
import { SchoolInfoSection } from "../sections/SchoolInfoSection";
import { EvaluationInfoSection } from "../sections/EvaluationInfoSection";
import { ClassSection } from "../sections/ClassSection";
import { EvaluationTypeSection } from "../sections/EvaluationTypeSection";
import { ActionsSection } from "../sections/ActionsSection";
import { MaterialsAndInfoSection } from "../sections/MaterialsAndInfoSection";
import { QuestionsDistributionSection } from "../sections/QuestionsDistributionSection";
import type { ClassData } from "@/lib/api";

interface FormStepProps {
  isDark: boolean;
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
  userData: any;
  loadingUser: boolean;
  classes: ClassData[];
  loadingClasses: boolean;
  activeProfile: any;
  evaluationTypes: EvaluationType_Option[];
  isGenerating: boolean;
  error: string;
  onGenerate: () => void;
}

export const FormStep: React.FC<FormStepProps> = ({
  isDark,
  formData,
  onFormChange,
  userData,
  loadingUser,
  classes,
  loadingClasses,
  activeProfile,
  evaluationTypes,
  isGenerating,
  error,
  onGenerate,
}) => {
  const isFormValid =
    !!formData.title && !!formData.subject && !!formData.class;

  useEffect(() => {
    console.log("[FormStep] Classes:", { classes, loadingClasses });
  }, [classes, loadingClasses]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl">
      <SchoolInfoSection
        isDark={isDark}
        activeProfile={activeProfile}
        userData={userData}
        loadingUser={loadingUser}
        professorName={formData.professorName}
        onProfessorNameChange={(value) => onFormChange("professorName", value)}
      />

      <EvaluationInfoSection
        isDark={isDark}
        title={formData.title}
        weight={formData.weight}
        dueDate={formData.dueDate}
        onTitleChange={(value) => onFormChange("title", value)}
        onWeightChange={(value) => onFormChange("weight", value)}
        onDateChange={(value) => onFormChange("dueDate", value)}
      />

      <ClassSection
        classes={classes}
        loadingClasses={loadingClasses}
        selectedClass={formData.class}
        onClassChange={(value) => onFormChange("class", value)}
        selectedSubject={formData.subject}
      />

      <EvaluationTypeSection
        isDark={isDark}
        selectedType={formData.type}
        evaluationTypes={evaluationTypes}
        onTypeChange={(value) => onFormChange("type", value)}
      />

      <div className="md:col-span-2">
        <QuestionsDistributionSection
          objetivas={formData.objetivas || 0}
          dissertativas={formData.dissertativas || 0}
          onObjetivasChange={(value) => onFormChange("objetivas", value)}
          onDissertativasChange={(value) =>
            onFormChange("dissertativas", value)
          }
        />
      </div>

      <div className="md:col-span-2">
        <MaterialsAndInfoSection
          isDark={isDark}
          additionalInfo={formData.additionalInfo || ""}
          onAdditionalInfoChange={(value) =>
            onFormChange("additionalInfo", value)
          }
          onPdfTextExtracted={(text) => onFormChange("pdfText", text)}
        />
      </div>

      <ActionsSection
        isDark={isDark}
        isGenerating={isGenerating}
        isFormValid={isFormValid}
        error={error}
        onGenerateClick={onGenerate}
      />
    </div>
  );
};
